/** Editable fields sent on office Location save — never include endorsement counters. T2-6903 */

export const LOCATION_EDITABLE_FIELDS = [
  'secondaryEmail',
  'accountingEmail',
  'phone',
  'primaryContact',
  'practiceName',
  'businessOwner',
  'address',
  'city',
  'province',
  'postalCode',
  'parking',
  'radiography',
  'ultrasonic',
  'avgApptTime',
  'charting',
  'software',
  'scentFreePolicy',
] as const

export type LocationEditableField = typeof LOCATION_EDITABLE_FIELDS[number]

export function normalizeLocationPhone(v?: string | null) {
  if (!v) return ''
  let d = v.replace(/\D/g, '')
  if (d.length > 10 && d[0] === '1') d = d.slice(1)
  return d
}

export function buildLocationUpdatePayload(
  form: Partial<Record<LocationEditableField | string, any>>,
): Partial<Record<LocationEditableField, any>> {
  const payload: Partial<Record<LocationEditableField, any>> = {}
  LOCATION_EDITABLE_FIELDS.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(form, key)) {
      payload[key] = form[key]
    }
  })
  if (Object.prototype.hasOwnProperty.call(form, 'phone')) {
    payload.phone = normalizeLocationPhone(form.phone)
  }
  return payload
}
